import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";
import { Layout1 } from "../ContentBox";
import { DivHover, DivHelp } from "./styled";

class TextView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }
  onHover = () => {
    this.setState({ hover: true });
  };
  onMouseOver = () => {
    this.setState({ hover: false });
  };
  render() {
    return (
      <DivHover
        onMouseLeave={this.onMouseOver.bind(this)}
        onMouseEnter={this.onHover.bind(this)}
      >
        <Layout {...this.props} type="TextView" />
        {this.state.hover && <DivHelp>Content</DivHelp>}
      </DivHover>
    );
  }
}

TextView.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  cell: PropTypes.array,
  layout: PropTypes.func
};

TextView.defaultProps = {
  childOf: "Content",
  values: {
    parent: "Content",
    type: "TextView",
    containerPadding: "0px",
    backgroundColor: "rgba(255,255,255,0)",
    lineHeight: "120%",
    letterSpacing: "1px",
    text:
      "<div>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>",
    href: {
      url: "",
      target: "",
      isCollection: false,
      collection: 0
    },
    isLink: false
  },
  layout: Layout1
};
export default TextView;



// WEBPACK FOOTER //
// ./src/editor/layout/components/Content/TextView.js